import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
import { MobileSlider } from "@faire/retailer-visitor-shared/components/MobileSlider/index";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";
var MOBILE_REGION_WIDTH = 156;
export var GeographicMapMobile = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SectionHeadingWrapper, {
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "pageHeaderSerifRegular",
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "oLZIWB",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Get more sales at home and abroad"
                            }
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: "2x"
            }),
            /*#__PURE__*/ _jsxs(MobileSlider, {
                numberOfSlides: 3,
                arrows: false,
                centerMode: true,
                centerPadding: "24px",
                slidesToShow: 2,
                slidesToScroll: 1,
                children: [
                    RetailerStore.get().isEurope ? /*#__PURE__*/ _jsx(MapNorthAmerica, {}) : /*#__PURE__*/ _jsx(MapEurope, {}),
                    /*#__PURE__*/ _jsx(MapAustralia, {}),
                    RetailerStore.get().isEurope ? /*#__PURE__*/ _jsx(MapEurope, {}) : /*#__PURE__*/ _jsx(MapNorthAmerica, {})
                ]
            })
        ]
    });
};
var MapEurope = function() {
    var isSSR = useIsSSR();
    var MOBILE_EU = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/135f63113b909cd894d4568a59a7cf071bff05837115b7dcfe678fbcad656134.png"
    }, isSSR, {
        width: MOBILE_REGION_WIDTH
    });
    return /*#__PURE__*/ _jsx(MapCard, {
        mapUrl: MOBILE_EU,
        name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "dmzck5",
            defaultMessage: [
                {
                    type: 0,
                    value: "Europe"
                }
            ]
        })
    });
};
var MapNorthAmerica = function() {
    var isSSR = useIsSSR();
    var MOBILE_NA = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/c1e3006584ec38a7ee9f399974db75677f10158be0849e793cd18e929977f6be.png"
    }, isSSR, {
        width: MOBILE_REGION_WIDTH
    });
    return /*#__PURE__*/ _jsx(MapCard, {
        mapUrl: MOBILE_NA,
        name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "3wnq0F",
            defaultMessage: [
                {
                    type: 0,
                    value: "North America"
                }
            ]
        })
    });
};
var MapAustralia = function() {
    var isSSR = useIsSSR();
    var MOBILE_AUS = optimizeImageUrl({
        url: "https://cdn.faire.com/fastly/1be730e0c48b75153ae88186884a550eb6ec2e7b9b220d8bc18b5aeefc741268.png"
    }, isSSR, {
        width: MOBILE_REGION_WIDTH
    });
    return /*#__PURE__*/ _jsx(MapCard, {
        mapUrl: MOBILE_AUS,
        name: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "DIzrSO",
            defaultMessage: [
                {
                    type: 0,
                    value: "Australia"
                }
            ]
        })
    });
};
var MapCard = function(param) {
    var mapUrl = param.mapUrl, name = param.name;
    return /*#__PURE__*/ _jsxs(GeographicCard, {
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: mapUrl,
                style: {
                    width: "100%"
                }
            }),
            /*#__PURE__*/ _jsx(DetailsTag, {
                flex: 1,
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: {
                        mobileAndAbove: "displaySSerifRegular",
                        tabletAndAbove: "pageHeaderSerifRegular"
                    },
                    children: name
                })
            })
        ]
    });
};
var SectionHeadingWrapper = styled.div.withConfig({
    componentId: "sc-26856f03-0"
})([
    "padding-left:",
    ";"
], getSpacing("3x"));
var GeographicCard = styled(Column).withConfig({
    componentId: "sc-26856f03-1"
})([
    "border:1px solid ",
    ";background-color:",
    ";margin:",
    ";"
], Core.border.muted, Decorative.tint.neutral, getSpacing(0, "1x"));
var DETAILS_HEIGHT = "128px";
/**
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/Tag/Tag#Tag"
 */ var DetailsTag = styled(Column).withConfig({
    componentId: "sc-26856f03-2"
})([
    "min-height:",
    ";max-height:",
    ";background-color:",
    ";padding:16px;border:1px solid ",
    ";box-sizing:border-box;"
], DETAILS_HEIGHT, DETAILS_HEIGHT, Core.surface.inverse, Core.border.muted);
